import axios from "axios";
import store from "@/store";
import router from "@/router";
import { Toast } from 'vant';

const service = axios.create({
    baseURL,
})

let toast = null;

service.interceptors.request.use(config => {
    config['data'] = Object.prototype.toString.call(config['data']) === '[object Object]' ? config['data'] : {};
    config['data']['appName'] = appName;
    config['data']['userId'] = store.state.userInfo.id;
    config['data']['userToken'] = store.state.userInfo.token;
    if (config.url !== '/game/bet' && config.url !== '/finance/info') toast = Toast.loading({ overlay: true, duration: 0 });
    return config;
});

service.interceptors.response.use(response => {
    if (toast) toast.clear();
    if (response.data.code !== '200') {
        Toast.fail({ message: response.data.message, className: 'errorToast'});
    } else {
        return response.data.res;
    }
}, error => {
    console.log('err' + error);
});

export default service;
